import { API } from "../config/AppConfig";
import { DASHBOARD_TILES_CLICK_STATS } from "../constants/Endpoints";

class ClientPreferenceStatsRepository {
    async getTilesClickHistoryDataglobal() {
            const res = await API.get(DASHBOARD_TILES_CLICK_STATS);
            return res;
        }
}

const clientPreferenceStatsRepository = new ClientPreferenceStatsRepository();
export default clientPreferenceStatsRepository;